import request from "./Requests";

const listRequestWrapper = async (entity) => {

    if (entity) {
        try {
            const response = await request({
                url: 'list/getData',
                method: "POST",
                data: {
                    id: entity + 'DefaultList'
                }
            });
            return response.content
        } catch (e) {
            console.log(e);
            return [];
        }
    }
};

export default listRequestWrapper;